"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const material_1 = require("@mui/material");
const react_1 = require("react");
const react_use_1 = require("react-use");
const strings_1 = require("../../../../constants/strings");
const zustandStore_1 = require("../../../../zustandStore");
const requestListMenu_1 = __importDefault(require("./requestListMenu"));
const SideMenuMyRequestAside = () => {
    const isRequestAsideOpen = (0, zustandStore_1.useZustand)(state => state.aside.requestAside.isOpen);
    const { openSideMenuOnDesktopView, setIsRequestAsideOpen } = (0, zustandStore_1.useZustand)();
    const isMobileWidth = (0, react_use_1.useMedia)('(max-width: 650px)');
    (0, react_1.useEffect)(() => {
        if (isRequestAsideOpen && !isMobileWidth) {
            openSideMenuOnDesktopView(false);
        }
    }, [isMobileWidth, isRequestAsideOpen]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Paper, { "data-testid": "sideMenu-drawer", "ts-variant": "sideMenuMyRequest", className: isRequestAsideOpen ? 'open' : 'closed', children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { component: "header", "ts-variant": "teamSwitcherHeaderTitle", children: strings_1.sideMenuStrings.SIDE_MENU_MY_REQUESTS_OPTION }), (0, jsx_runtime_1.jsx)(Close_1.default, { "ts-variant": "teamSwitcherCloseIcon", onClick: () => {
                    setIsRequestAsideOpen(false);
                    if (!isMobileWidth) {
                        openSideMenuOnDesktopView(false);
                    }
                } }), (0, jsx_runtime_1.jsx)(requestListMenu_1.default, {})] }));
};
exports.default = SideMenuMyRequestAside;
